import React from "react";
import { useNavigate} from "react-router-dom";
import TableData from "../Partials/TableData3";

function Listmachine() {
  const path = "Machine";
  const navigate = useNavigate();

   const editClick = (item) => {
    //  console.log('Machine-ID:',item.machine_id)
    navigate(`../addnewmachine/${item.machine_id}`);
  }

  return (
    <React.Fragment>
      <div  className="add-user-container">
        <div className="headingdiv">
          <span className="componet-title">Machine List</span>

          <div>
            <button
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </button>
          </div>
        </div>

        <div className="option-btn">
          <button
            onClick={() => {
              navigate("/addnewmachine");
            }}
          >
            Add New Machine
          </button>
        </div>

        <TableData path={path} editClick={editClick} />
      </div>
    </React.Fragment>
  );
}

export default Listmachine;
